import { memo } from 'react'

import type { AcfSectionWithSidebarItem, AcfSectionWithSidebarProps } from '@typings'
import { RaContainer, RaGrid, RaGridItem } from '@components/core/index.core'
import { RaSidebarComponent } from '@components/features/RaSidebarComponent/RaSidebarComponent'
import { RaSidebarSection } from '@components/features/RaSidebarSection/RaSidebarSection'
import { Loop } from '@utilities/helpers/core.helpers'

export const AcfSectionWithSidebar = memo(
  ({ section_with_sidebar_repeater }: AcfSectionWithSidebarProps) => {
    return (
      <RaContainer>
        <RaGrid gap={48}>
          {Loop(section_with_sidebar_repeater, (item: AcfSectionWithSidebarItem, i: number) => {
            if (item.type === 'section')
              return (
                <RaGridItem
                  key={i}
                  md={8}
                  lg={7}>
                  <RaSidebarSection {...item} />
                </RaGridItem>
              )

            if (item.type === 'sidebar')
              return (
                <RaGridItem
                  key={i}
                  md={4}
                  lg={5}>
                  <RaSidebarComponent {...item} />
                </RaGridItem>
              )
          })}
        </RaGrid>
      </RaContainer>
    )
  },
)
